
import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { history } from '../../routes';
import config from '../../config';

import { ToastContainer, notify } from '../../libraries/notifications';
import appointmentsActions from '../../context/appointments/actions';
import usersActions from '../../context/users/actions';
import associationsActions from '../../context/associations/actions';
import videoActions from '../../context/video/actions';

import LayoutSmall from '../../components/layout/LayoutSmall';
import Icon from '../../libraries/icons';
import MessagesActions from '../../context/messages/actions'

import Button from '../../components/commons/Button';
import { isEmptyObject, getOwner, setTimeZeroDateWithTZ, getObjectWithJsonArrayFilter, changeTimeInDate } from '../../libraries/utils';
import { zonedTimeToUtc } from 'date-fns-tz';

class BookingClinicHistory extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      patient: null,
      submitting: false,
    }
  }
  
  componentDidMount() {
    if (isEmptyObject(this.props.location.state)) { 
      history.push(config.ROUTES.PROFESSIONALS);
    } else {
      const { appointment_type, professional, date, time, appointment_location, slot } = this.props.location.state;
      console.log("__slot", slot)
      this.setState({appointment_type, professional, date, time, appointment_location, slot});
      
      this.getUser()
    }
  }

  getUser = async () => {
    await this.props.onGetUser({ id: this.props.auth.user.id });
    const error = this.props.user.error;
    if (error) {
      notify(this.t(error.message));
    } else {
      this.setState({ patient: this.props.user.item });
    }
  }
  
  onSubmit = async (clinicalHistory) => {
    this.setState({submitting: true})
    const { slot, date, time, appointment_type, professional, patient, appointment_location } = this.state;

    const dateAndTime = changeTimeInDate(time, new Date(date));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const utcDate = zonedTimeToUtc(dateAndTime, timeZone) 
    console.log('dateAndTime', dateAndTime);
    console.log('utcDate', utcDate.toISOString());
    console.log('timeZone', timeZone);

    //TODO cambiar esto por la ubicacion real dependiendo de la configuracion de booking seleccionada al elegir fecha y hora
    const location = appointment_type === config.TRANSACTIONS.BOOK.SUB_TYPE.VISIT ? appointment_location : null
    console.log('LOCATION', location);

    let time_slot = slot;
    time_slot = {
      id: time_slot.id,
      start_time: time_slot.start_time,
      end_time: time_slot.end_time,
    }

    const data = {
      type: config.TRANSACTIONS.BOOK.TYPE,
      sub_type: appointment_type,
      status: config.TRANSACTIONS.BOOK.STATUS.BOOKED,
      date: utcDate,
      source: getOwner(professional), //get owner id usuario medico
      target: getOwner(this.props.auth.user), //id paciente, owner de usuario getOwner(usuario
      owner: config.OWNER.SYSTEM, //variable custom system
      json_data: { 
        time,
        time_slot,
        clinicalHistory,
        professional,
        patient,
        professional_name: professional.name,
        location: appointment_location,
      },
    }

    if(data.sub_type === config.TRANSACTIONS.BOOK.SUB_TYPE.VIDEO){
      if(professional.bio){
        await this.props.onGetVideoToken(professional.bio);
        const error = this.props.video.error;
        if (error) {
          notify(this.t(error));
        } else {
          const video_data = {...this.props.video.data}
          data.json_data.video_token = video_data.data.token 
          //console.log("____token", this.props.video.data.token)
          //data.json_data.video_token = this.props.video.data
        }
   
      }
    }
    
    const data_filter_arr = 
      [
        "type","sub_type","status","date","source","target","owner","clinicalHistory","time","location","professional_name","time_slot","video_token",
        {professional: ["id","accounts","first_name","last_name","profile_image","specialty","bio"]},
        {patient: ["id","accounts","first_name","last_name","profile_image","birth_date","gender","identification","identification_type","insurance","insurance_number"]}
      ]

    const filtered_data = getObjectWithJsonArrayFilter(data, data_filter_arr)
    
    console.log(filtered_data)
      
    await this.props.onSaveAppointment(filtered_data);
    const appointment = this.props.appointments;
    if (appointment.error) {
      notify(this.t(appointment.error.message));
      this.setState({submitting: false})
    } else {
      const asoc_data = {
        type: config.TYPES.USER_ASSOCIATION.PATIENT_PROFESSIONAL, 
        source: filtered_data.json_data.professional.id,
        target: filtered_data.json_data.patient.id,
      }
      await this.props.onSaveAssociation(asoc_data);
      const association = this.props.association;
        
      if (association.error) {
        notify(this.t(association.error.message));
        this.setState({submitting: false})
      } else {

        const payload = {
          subject: config.TRANSACTIONS.BOOK.TYPE,
          body: config.MESSAGES.CONFIG.BOOK.BODY,
          type: config.MESSAGES.TYPE.NOTIFICATION,
          source: this.props.auth.user.id,
          target: professional.id,
        }
        await this.props.onSendNotification(payload)
        const notification = this.props.message;
        if (notification.error) {
          notify(this.t(notification.error.message))
        }

        history.push({
          pathname: config.ROUTES.BOOKING.SUCCESS,
          state: {
            title: "Turno reservado con éxito",
            button:{
              text: "Aceptar",
              route: config.ROUTES.PROFESSIONALS,
            },
            button2:{
              text: "Ver Consultas",
              route: config.ROUTES.APPOINTMENTS.LIST
            }
          }
        })
      }
    }
  }


  render() {
    const { patient } = this.state
    return (
      <LayoutSmall
        main={{ className: ""}}
        header={{
          className: "!bg-transparent",
        }}
        container={{ className: "px-0"}}
      >
        <ToastContainer/>
        <section className="w-full max-w-lg mx-auto p-4 mt-3 text-base-content">
          <div className="text-center p-10">
            <Icon className="h-24 w-24 mx-auto mb-3 text-success" name="information_circle" />
            <h3 className="mb-5">{this.t("¿Desea compartir su historia clínica con el médico?")}</h3>
            {/* <p className="text-gray-700">{this.t(config.TRANSLATE.CLINIC_HISTORY)}</p> */}
          </div> 
          <div className="grid grid-cols-2 gap-3">
            <Button
              className="btn-ghost btn-block"
              title={this.t("No ahora")}
              onClick={()=>{this.onSubmit(false)}}
              disabled={!patient}
            />
            <Button
              className="btn-accent btn-block"
              title={this.t("Compartir")}
              onClick={()=>{this.onSubmit(true)}}
              disabled={!patient || this.state.submitting}
            />
          </div>
        </section>
      </LayoutSmall>
    ) 
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    appointments: state.appointments.current,
    user: state.users.current,
    association: state.associations.current,
    message: state.messages.current,
    video: state.video,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSaveAppointment: (params) => dispatch(appointmentsActions.saveOrUpdate(params)),    
    onSaveAssociation: (params) => dispatch(associationsActions.saveOrUpdate(params)),    
    onGetUser: (params) => dispatch(usersActions.get(params)),
    onSendNotification: (payload) => dispatch(MessagesActions.saveOrUpdate(payload)),
    onGetVideoToken: (params) => dispatch(videoActions.getToken(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(BookingClinicHistory));

